export default "__VITE_ASSET__DGyFK3tl__"